import SearchIcon from 'components/icons/SearchIcon/SearchIcon';
import { type FC, type Ref, forwardRef, useEffect } from 'react';
import { TextInput } from '../TextInput';
import { type TextInputProps } from '../TextInput/TextInput';

export interface SearchBarProps extends TextInputProps {
  iconPosition?: 'start' | 'end';
  showSearchIcon?: boolean;
  onRender?: () => void;
  ref?: any;
}

const SearchBar: FC<SearchBarProps> = forwardRef(
  (
    { iconPosition = 'start', onRender, showSearchIcon = true, ...props },
    ref: Ref<HTMLInputElement>
  ) => {
    useEffect(() => {
      onRender?.();
    }, []);

    return (
      <TextInput
        addorment={
          showSearchIcon
            ? iconPosition === 'start'
              ? { startAddorment: <SearchIcon role="icon" /> }
              : { endAddorment: <SearchIcon role="icon" /> }
            : undefined
        }
        placeholder="Search"
        ref={ref}
        {...props}
      />
    );
  }
);
export default SearchBar;
